import React, {useContext} from "react"
import {Box, Pagination, Typography} from "@mui/material"
import PropTypes from "prop-types"
import {getMerkmal} from "../../../../anwendungskonfigurator/misc/widget-functions"
import {DataContext} from "../../../context/DataContextProvider"
import {ActionContext} from "../../../context/ActionContextProvider"


const PaginationWidget = ({widget}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const {triggerAction} = useContext(ActionContext)
    const {action, subtext, perPage = 3} = widget

    const pagePointer = getMerkmal(widget)?.pointer
    const list = getDataFromPointer(subtext) ?? []
    const size = Number(perPage) || 3
    const count = Math.max(1, Math.ceil(list.length / size))
    const page = (getDataFromPointer(pagePointer) ?? 0) + 1

    const handleChange = (event, value) => {
        action && triggerAction(action, value - 1)
    }

    const totalItems = list.length
    const from = totalItems === 0 ? 0 : (page - 1) * size + 1
    const to = Math.min(page * size, totalItems)

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            sx={{width: '100%'}}
        >
            <Typography variant="body2" color="text.secondary">
                {from}-{to} von {totalItems}
            </Typography>

            <Pagination
                count={count}
                page={page}
                onChange={handleChange}
                showFirstButton
                showLastButton
            />
        </Box>
    )
}

PaginationWidget.propTypes = {
    widget: PropTypes.object,
}

export default PaginationWidget
